import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const ProtectedRoute = ({ children }) => {
  const { adminUser } = useApp();
  if (!adminUser) return <Navigate to="/admin" replace />;
  return children;
};

export default ProtectedRoute;
